import axios from 'axios';

export default class CrudService {
    constructor(controller, component) {
        this.component = component;
        this.controller = controller;
        this.baseUrl = process.env.NODE_ENV === 'production' 
            ? 'https://nextapi.logonomy.ir'
            : 'http://localhost:5051';
    }

    getList = (count, pageNumber, filters, sortField, sortOrder) => {
        return axios.get(`${this.baseUrl}/api/${this.controller}/Get`,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                },
                params: {
                    count, pageNumber, filters, sortField, sortOrder
                }
            }).then(res => res.data)
            .catch(error => {
                this.showError(error);
            });
    }

    getMetaData = () => {
        return axios.get(`${this.baseUrl}/api/${this.controller}/MetaData`,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            })
            .then(res => res.data)
            .catch(error => {
                this.showError(error);
            });
    }

    create = (data) => {
        return axios.post(`${this.baseUrl}/api/${this.controller}/Create`,
            {
                model: data
            }, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem("jwt")
            }
        })
            .then(res => res.data)
            .catch(error => {
                this.showError(error);
            });
    }

    update = (data) => {
        return axios.put(`${this.baseUrl}/api/${this.controller}/Update/${data.id}`,
            {
                model: data
            }, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem("jwt")
            }
        })
            .then(res => res.data)
            .catch(error => {
                this.showError(error);
            });;
    }
    getItem = (id) => {
        return axios.get(`${this.baseUrl}/api/${this.controller}/Get/${id}`,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            })
            .then(res => res.data).catch(error => {
                this.showError(error);
            });
    }

    deleteItem = (id) => {
        return axios.delete(`${this.baseUrl}/api/${this.controller}/Delete/${id}`,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            })
            .then(res => res.data).catch(error => {
                this.showError(error);
            });
    }

    deleteItems = (ids) => {
        return axios.delete(`${this.baseUrl}/api/${this.controller}/BatchDelete`,
            {
                data: { ids: ids.join(',') }
            },
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            })
            .then(res => res.data)
            .catch(error => {
                this.showError(error);
            });
    }

    showError = (error) => {
        this.component.$toast.add({
            severity: "error",
            summary: error.response.data,
            life: 3000
        });
    }

}
